<template>
	<div>
		<v-dialog @keydown.esc="setInitialValue" @click:outside="setInitialValue" v-model="dialog" max-width="500">
			<v-card class="pa-6 text-center">
				<div class="user-matching-options-header">
					<div>User matching options</div>
					<v-col align="center" style="min-width: 250px; height: 70px; position: relative; overflow: hidden">
						<v-row no-gutters class="fill-height align-center">
							<v-col cols="auto">For</v-col>
							<v-col class="text-left pl-2" cols="auto">
								<v-card class="service-icon ac_card integration inline-block">
									<div class="centerdXY">
										<SIcon :name="appInfo.service_slug" eager :width="15" />
									</div>
								</v-card>
							</v-col>
							<v-col class="pl-2 param-path" cols="auto"> {{ appInfo.service_name }} - {{ actionName }} - {{ paramName }} </v-col>
						</v-row>
					</v-col>
				</div>

				<div class="user-matching-header flex-centerize">
					<div>What do you want to happen if we can't find the Ply user in {{ appInfo.service_name }}?</div>
				</div>

				<v-radio-group v-model="fallbackType">
					<v-radio
						v-for="(item, i) in fallbackChoices"
						:key="i"
						:label="item.label"
						:value="item.value"
						:disabled="item.disabled"
						on-icon="mdi-radiobox-marked"
						off-icon="mdi-radiobox-blank"
					>
						<template v-slot:label>
							<div>
								<v-input> {{ item.label }} </v-input>
								<v-select
									v-if="item.showSelection"
									class="slct set fallback-selection"
									:items="chooseFromItems"
									hide-details
									outlined
									dense
									placeholder="Choose fallback"
									v-model="fallbackDetails"
									item-text="option"
									return-object
									append-icon="fa fa-chevron-down"
								/>
							</div>
						</template>
					</v-radio>
				</v-radio-group>

				<div class="user-matching-info">
					<div>You will get an email when this haapens</div>
					<div><a href="" target="_blank"> why this happens?</a></div>
				</div>
				<div class="actions mt-8">
					<v-btn width="145" height="45" class="mx-2" @click="discardChanges">Cancel</v-btn>
					<v-btn width="145" height="45" class="mx-2" @click="saveAndClose" color="primary">Save and close</v-btn>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import UserMatchingService, { USER_MATCHING_SELECT_OPTIONS } from '@/utils/UserMatchingService';
export default {
	name: 'UserMatchingFallbackModal',
	components: {},
	props: {
		showDialog: { type: Boolean },
		isRequired: { type: Boolean },
		appInfo: { type: Object },
		fallbackInit: { type: Object },
		actionName: { type: String },
		paramName: { type: String },
		chooseFromItems: { type: Array },
	},
	watch: {
		showDialog: {
			handler(newV) {
				if (newV) {
					this.localDialog = true;
				}
			},
		},
		localDialog: {
			handler(newV) {
				this.$emit('update:showDialog', newV);
			},
		},
		fallbackType: {
			handler(type) {
				this.fallbackDetails = undefined;
				this.fallback.type = type;
			},
		},
		fallbackDetails: {
			handler(details) {
				const value = {};
				if (details) {
					if (details.option) {
						value['name'] = details.option;
					}
					if (details.value) {
						value['id'] = details.value;
					}
				}
				this.fallback.details = value;
			},
		},
		chooseFromItems: {
			handler() {
				this.setInitialValue();
			},
		},
	},
	mounted() {
		this.setInitialValue();
	},
	computed: {
		dialog: {
			set(value) {
				this.$emit('update:showDialog', value);
			},
			get() {
				return this.showDialog;
			},
		},
		fallbackChoices() {
			return [
				{
					value: USER_MATCHING_SELECT_OPTIONS.EMPTY,
					label: 'Leave field empty',
					showSelection: false,
					disabled: this.isRequired,
				},
				{
					value: USER_MATCHING_SELECT_OPTIONS.CHOOSE,
					label: 'Use a fallback option',
					showSelection: this.fallbackType == USER_MATCHING_SELECT_OPTIONS.CHOOSE,
					disabled: false,
				},
				{
					value: USER_MATCHING_SELECT_OPTIONS.ERROR,
					label: 'Display an error message and notify me',
					showSelection: false,
					disabled: false,
				},
			];
		},
	},
	methods: {
		saveAndClose() {
			if (this.fallback) {
				this.$emit('update-params-fallback', this.fallback);
			}
			this.dialog = false;
		},
		discardChanges() {
			this.setInitialValue();
			this.dialog = false;
		},
		setInitialValue() {
			const defaultFallbackType = UserMatchingService.initialFallbackType(this.isRequired);
			this.fallbackType = this.fallbackInit && this.fallbackInit.type ? this.fallbackInit.type : defaultFallbackType;
			let details = undefined;
			if (this.fallbackInit && this.fallbackInit.details) {
				details = {};
				if (this.fallbackInit.details.name) {
					details['option'] = this.fallbackInit.details.name;
				}
				if (this.fallbackInit.details.id) {
					details['value'] = this.fallbackInit.details.id;
				}
			}
			this.fallbackDetails = details;
		},
	},
	data: () => ({
		fallback: { type: USER_MATCHING_SELECT_OPTIONS.ERROR, details: {} },
		fallbackType: USER_MATCHING_SELECT_OPTIONS.ERROR,
		fallbackDetails: undefined,
	}),
};
</script>
<style scoped lang="scss">
.user-matching-options-header {
	padding: 10px;
	font-weight: 600;
	font-size: small;

	.service-icon {
		width: 25px;
		height: 25px;
	}
}

.user-matching-header {
	padding: 10px;
	font-weight: 600;
	font-size: large;
}

.user-matching-body {
	padding: 10px;
	overflow: auto;
}

.user-matching-info {
	font-size: small;
	color: gray;
	text-align: start;
}

.fallback-selection {
	padding: 0px 30px;
	display: inline-block;
}
</style>
